/* CILIGA — scripts propios (prefijo mt-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-mt-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(String(el.getAttribute('data-mt-contar')).replace(',', '.')) || 0;
      var dec = (String(el.getAttribute('data-mt-contar')).split(/[.,]/)[1] || '').length;
      var sep = String(el.getAttribute('data-mt-contar')).indexOf(',') > -1 ? ',' : '.';
      if (reduce) { el.textContent = fin.toFixed(dec).replace('.', sep); return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', sep);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    var cajas = (root || document).querySelectorAll('[data-mt-producto]');
    cajas.forEach(function (caja) {
      if (caja.dataset.mtListo) return;
      caja.dataset.mtListo = '1';
      var datosEl = caja.querySelector('[data-mt-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(datosEl ? datosEl.textContent : '[]'); } catch (e) {}
      var principal = caja.querySelector('[data-mt-principal]');
      var minis = caja.querySelectorAll('[data-mt-mini]');
      var inputId = caja.querySelector('input[name="id"]');
      var precio = caja.querySelector('[data-mt-precio]');
      var tachado = caja.querySelector('[data-mt-tachado]');
      var ahorro = caja.querySelector('[data-mt-ahorro]');
      var boton = caja.querySelector('[data-mt-boton]');
      var nombreSel = caja.querySelectorAll('[data-mt-sel-nombre]');
      var aviso = caja.querySelector('[data-mt-aviso]');
      var formato = caja.getAttribute('data-mt-formato') || '{{amount}}';
      var txtComprar = boton ? boton.getAttribute('data-mt-txt') : '';
      var txtAgotado = boton ? boton.getAttribute('data-mt-agotado') : '';

      function dinero(c) {
        var n = (c / 100);
        var conComa = /amount_with_comma_separator|amount_no_decimals_with_comma_separator/.test(formato);
        var sinDec = /amount_no_decimals/.test(formato);
        var s = sinDec ? Math.round(n).toString() : n.toFixed(2);
        if (conComa) s = s.replace('.', ',');
        s = s.replace(/\B(?=(\d{3})+(?!\d))/g, conComa ? '.' : ',');
        return formato.replace(/\{\{\s*\w+\s*\}\}/, s);
      }

      function verImagen(src, srcset) {
        if (!principal || !src) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset');
          principal.style.opacity = '1';
        }, 150);
      }

      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('is-activa'); });
          m.classList.add('is-activa');
          verImagen(m.getAttribute('data-src'), m.getAttribute('data-srcset'));
        });
      });

      function opcionesElegidas() {
        var sel = [];
        caja.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        return sel;
      }

      function actualizar() {
        var sel = opcionesElegidas();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        caja.querySelectorAll('[data-mt-opcion]').forEach(function (fs, i) {
          var leyenda = fs.querySelector('[data-mt-sel-nombre]');
          if (leyenda) leyenda.textContent = sel[i] || '';
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false;
            if (ahorro) { ahorro.hidden = false; ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
          } else { tachado.hidden = true; if (ahorro) ahorro.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txtComprar : txtAgotado;
        }
        if (v.featured_image && v.featured_image.src) {
          var mini = caja.querySelector('[data-mt-mini][data-media-id="' + (v.featured_media ? v.featured_media.id : '') + '"]');
          minis.forEach(function (x) { x.classList.remove('is-activa'); });
          if (mini) { mini.classList.add('is-activa'); verImagen(mini.getAttribute('data-src'), mini.getAttribute('data-srcset')); }
          else { verImagen(v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200'); }
        }
        if (window.history && window.history.replaceState && caja.hasAttribute('data-mt-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      caja.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });

      /* cantidad */
      var cant = caja.querySelector('[data-mt-cantidad]');
      caja.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!cant) return;
          var n = parseInt(cant.value, 10) || 1;
          n += parseInt(b.getAttribute('data-mt-cant'), 10);
          cant.value = Math.max(1, n);
        });
      });

      /* añadir al carrito (abre el carrito lateral de Dawn si existe) */
      var form = caja.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          var notif = document.querySelector('cart-notification');
          var destino = drawer || notif;
          if (!destino || !window.fetch) return; // envío normal → página del carrito
          ev.preventDefault();
          if (aviso) aviso.textContent = '';
          boton.disabled = true; boton.classList.add('is-cargando');
          var fd = new FormData(form);
          var secciones = destino.getSectionsToRender ? destino.getSectionsToRender().map(function (s) { return s.id; }) : [];
          if (secciones.length) { fd.append('sections', secciones.join(',')); fd.append('sections_url', window.location.pathname); }
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) {
              if (aviso) aviso.textContent = res.description || res.message || 'No se pudo añadir.';
              return;
            }
            if (destino.renderContents) {
              destino.renderContents(res);
              if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
          }).catch(function () { form.submit(); })
            .finally(function () { boton.classList.remove('is-cargando'); actualizarDisponible(); });
        });
      }
      function actualizarDisponible() {
        var v = variantes.find(function (x) { return String(x.id) === String(inputId && inputId.value); });
        if (boton) boton.disabled = v ? !v.available : false;
      }
    });
  }

  function initTodo(root) { initReveal(root); initCifras(root); initProducto(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
